module.exports = __webpack_public_path__ + "img/me_user.742b2de5.svg";